<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="currentId ? '编辑 cookie' : '新建 cookie'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- entity_name -->
      <a-form-item
        label="主体名称"
        name="entity_name"
        :rules="[{ required: true, message: '请输入'  }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.entity_name"
        />
      </a-form-item>
      <!-- cookie -->
      <a-form-item
        label="cookie"
        name="cookie"
        :rules="[{ required: true, message: '请输入'  }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.cookie"
        />
      </a-form-item>
      <!-- 是否过期 -->
      <a-form-item
        label="是否过期"
        name="is_expire"
      >
        <a-switch
          v-model:checked="formState.is_expire"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, defineEmits } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import { cookieDetail, cookieSave } from '@/api/copyright'

// 定义事件
const emit = defineEmits(['success'])

// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 当前编辑的id
let currentId = ref(null)
// 表单
let formState = reactive({
  // entity_name
  entity_name: undefined,
  // cookie
  cookie: undefined,
  // 过期状态 (true/false)
  is_expire: false,
})

// 打开抽屉
function showDrawer (id) {
  // 展开
  visible.value = true
  // 设置当前id
  currentId.value = id || null
  // 获取详情
  getDetail()
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 重置
    RefForm.value.resetFields()
    visible.value = false
    formState.entity_name = undefined
    formState.cookie = undefined
    formState.is_expire = false
    currentId.value = null
  }
}

// 获取详情
function getDetail () {
  // 如果是新建，不需要获取详情
  if (!currentId.value) {
    formState.entity_name = undefined
    formState.cookie = undefined
    formState.is_expire = false
    return
  }
  // 编辑时获取详情
  const params = { id: currentId.value }
  cookieDetail(params).then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      formState.entity_name = data.entity_name
      formState.cookie = data.cookie
      // 将 0/1 转换为 true/false
      formState.is_expire = data.is_expire === 1 || data.is_expire === '1'
    } else {
      message.error(res.message || msg)
    }
  }).catch(err => {
    message.error(err.message || '获取详情失败')
  })
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      entity_name: formState.entity_name,
      cookie: formState.cookie,
      // 将 true/false 转换为 0/1
      is_expire: formState.is_expire ? 1 : 0,
    }
    // 如果有id，添加id字段
    if (currentId.value) {
      params.id = currentId.value
    }
    cookieSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 触发成功事件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    }).catch(err => {
      isLoading.value = false
      message.error(err.message || '操作失败')
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>